import React from 'react';
import { useParams } from 'react-router-dom';
// import { ImageMedia } from '../../components/imports';
import { projects } from '../../data/worklog';
import useLink from '../../hooks/useLink';

const Content = () => {

  const { projectId } = useParams();
  const prLink = useLink();
  const thisProject = projects.find(project => prLink(project.client) === projectId);

  return (
    <div className='flex flex-col items-start justify-start h-fit w-full relative overflow-y-visible'>

      <div className='resp'>
        <div className='flexV start maxW '>
          <h4 className='font-light mx-auto text-left'>{thisProject.metadata.overview}</h4>
        </div>
      </div>


     {/*  <div className='flex flex-col mt-20 w-full items-center justify-center *:w-full resp relative px-0 rounded-lg overflow-clip'>
        <ImageMedia src={require(`./_cover.jpg`)} className="w-full object-cover z-[1]" />
        <ImageMedia src={require(`./_cover.jpg`)} className="w-full object-cover translate-y-[-25%]" />
      </div> */}

    </div>

  )
}

export default Content